import axios from "axios";

class User {
    getInfo() {
        return axios.get('/api/v1/user-info');
    }
}

export default User